var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useEffect, useMemo, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { TagType } from '@common/api';
import { evaluatorApi } from '@data/rest/api';
import * as baobab from '@data/baobab/baobab';
import { isGroupTag } from '@data/tag/types';
import { KpiColumnOperation, KpiColumnType } from '@util/enums';
import { LastPromise } from './modelTable';
export default function useKPIData(kpiCols, kpiRows, widgetConfig, widgetId, tagById, tagSlicersTagIds) {
    var _this = this;
    var _a = __read(useState(null), 2), data = _a[0], setData = _a[1];
    var _b = __read(useState(null), 2), lastFetched = _b[0], setLastFetched = _b[1];
    var _c = __read(useState(''), 2), currentDataKey = _c[0], setCurrentDataKey = _c[1];
    var evaluateLast = useRef(new LastPromise());
    var rowLimit = 1000;
    //cols:
    var colsDataStrings = useMemo(function () {
        var columnDataStrings = [];
        kpiCols.forEach(function (kpiCol) {
            switch (kpiCol.type) {
                case KpiColumnType.SELECTOR:
                    columnDataStrings.push(getSelectorColDataString(kpiCol, widgetConfig.useTagSlicers ? tagSlicersTagIds : null, tagById));
                    break;
                case KpiColumnType.DIFF:
                    var diffColDataString = '';
                    var optADataIdx = kpiCols.findIndex(function (kc) { return kc.id === kpiCol.opA; });
                    var optBDataIdx = kpiCols.findIndex(function (kc) { return kc.id === kpiCol.opB; });
                    var optADataString = columnDataStrings[optADataIdx];
                    var optBDataString = columnDataStrings[optBDataIdx];
                    if (optADataString && optBDataString) {
                        diffColDataString = getDiffColDataString(kpiCol.operation, "(".concat(optADataString, ")"), "(".concat(optBDataString, ")"));
                    }
                    columnDataStrings.push(diffColDataString);
                    break;
                default:
                    columnDataStrings.push('');
            }
        });
        return columnDataStrings;
    }, [kpiCols, JSON.stringify(tagSlicersTagIds)]);
    // rows:
    var rowsDataStrings = useMemo(function () {
        var rds = [];
        var maxKpiRows = Math.min(rowLimit, kpiRows.length);
        for (var i = 0; i < maxKpiRows; i++) {
            if (kpiRows[i].tableTagOption !== undefined) {
                // don't evaluate rows which are tables for dynamic items
                rds.push('');
            }
            else {
                // create data string for normal rows
                rds.push(getDataString(kpiRows[i].tags.filter(function (id) { return !isGroupTag(tagById[id]); })));
            }
        }
        return rds;
    }, [kpiRows]);
    var key = useMemo(function () {
        var newKey = rowsDataStrings.join(',') + colsDataStrings.join(',');
        if (key !== newKey) {
            return newKey;
        }
        else {
            return key;
        }
    }, [colsDataStrings, rowsDataStrings]);
    // data fetch:
    var fetch = function (rs, cs) { return __awaiter(_this, void 0, void 0, function () {
        var res, error_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    baobab.root.select('state', 'widgetsLoading', widgetId).set(true);
                    return [4 /*yield*/, evaluateLast.current.pushPromise(function () { return __awaiter(_this, void 0, void 0, function () {
                            var data;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, evaluatorApi.evaluate({ rows: rs, cols: cs })];
                                    case 1:
                                        data = _a.sent();
                                        return [2 /*return*/, {
                                                key: key,
                                                data: data,
                                            }];
                                }
                            });
                        }); })];
                case 1:
                    res = _a.sent();
                    setLastFetched(res);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    toast.error('Error loading table data.');
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 3:
                    baobab.root.select('state', 'widgetsLoading', widgetId).set(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (rowsDataStrings.length > 0 && colsDataStrings.length > 0) {
            if (key !== currentDataKey && data) {
                setData(null);
            }
            fetch(rowsDataStrings, colsDataStrings);
        }
    }, [key]);
    useEffect(function () {
        if (lastFetched && lastFetched.data && key === (lastFetched === null || lastFetched === void 0 ? void 0 : lastFetched.key)) {
            setCurrentDataKey(lastFetched.key);
            setData(lastFetched.data);
            baobab.root.select('state', 'widgetsLoading', widgetId).set(false);
        }
    }, [lastFetched]);
    var atLeastOneColHasAccountTag = useMemo(function () {
        var _a;
        var hasAccTag = false;
        for (var i = 0; i < kpiCols.length; i++) {
            if (hasAccTag) {
                break;
            }
            var tags = kpiCols[i].tags || [];
            for (var i_1 = 0; i_1 < tags.length; i_1++) {
                if (hasAccTag) {
                    break;
                }
                if (tagById[tags[i_1]] && ((_a = tagById[tags[i_1]]) === null || _a === void 0 ? void 0 : _a.type) === TagType.Account) {
                    hasAccTag = true;
                }
            }
        }
        return hasAccTag;
    }, [kpiCols]);
    // filter showZeroSumRows
    var filteredRowsWithData = useMemo(function () {
        var _a, _b;
        var frwd = [];
        var dataCells = data || [];
        if (!widgetConfig.showZeroSumRows) {
            for (var idx = 0; idx < kpiRows.length; idx++) {
                var row = kpiRows[idx];
                var dataRow = (_a = dataCells[idx]) !== null && _a !== void 0 ? _a : [];
                var hasNumber = dataRow.some(function (cell) { return cell.value !== null && cell.value !== 0; });
                // include rows with numbers, table option rows and all rows with no account tags
                if ((hasNumber ||
                    (!row.hasAccountTags && !atLeastOneColHasAccountTag) ||
                    row.tableTagOption !== undefined) &&
                    frwd.length < rowLimit) {
                    frwd.push(__assign(__assign({}, row), { data: dataRow }));
                }
            }
        }
        else {
            var maxKpiRows = Math.min(rowLimit, kpiRows.length);
            for (var i = 0; i < maxKpiRows; i++) {
                frwd.push(__assign(__assign({}, kpiRows[i]), { data: (_b = dataCells[i]) !== null && _b !== void 0 ? _b : [] }));
            }
        }
        return frwd;
    }, [kpiRows, data, widgetConfig.showZeroSumRows]);
    var sortedRowsWithData = useMemo(function () {
        return widgetConfig.sort !== null && data !== null && data.length > 0
            ? sortKPI(filteredRowsWithData, kpiCols, widgetConfig.sort)
            : filteredRowsWithData;
    }, [filteredRowsWithData, kpiCols, widgetConfig.sort, data]);
    return { rows: sortedRowsWithData, cols: kpiCols };
}
export function getDiffColDataString(operation, aDataString, bDataString) {
    switch (operation) {
        case KpiColumnOperation.PLUS:
            return "".concat(aDataString, "+").concat(bDataString);
        case KpiColumnOperation.MINUS:
            return "".concat(aDataString, "-").concat(bDataString);
        case KpiColumnOperation.MULTIPLY:
            return "".concat(aDataString, "*").concat(bDataString);
        case KpiColumnOperation.DIVIDE:
            return "".concat(aDataString, "/").concat(bDataString);
        case KpiColumnOperation.PERCENT:
            return "(".concat(aDataString, "/").concat(bDataString, ")*100");
        case KpiColumnOperation.PERCENT_ROUNDED_THOUSANDS:
            return "(round(".concat(aDataString, "/1000,0)/round(").concat(bDataString, "/1000,0))*100");
        case KpiColumnOperation.DIFF_PERCENT:
            return "(((".concat(aDataString, ")-(").concat(bDataString, "))/(").concat(bDataString, "))*100");
        default:
            return '';
    }
}
function getSelectorColBasicDataString(temporalGenerator, tags) {
    if (temporalGenerator && temporalGenerator.length > 0) {
        var dataStrings_1 = [];
        temporalGenerator.forEach(function (tf) {
            dataStrings_1.push("".concat(getDataString(__spreadArray(__spreadArray([], __read(tags), false), [tf.yearTagId, tf.monthTagIds.sort(function (a, b) { return a - b; })], false))));
        });
        return "(".concat(dataStrings_1.join('+'), ")");
    }
    else {
        return getDataString(tags);
    }
}
export function getSelectorColDataString(kpiCol, tagSlicerTagIds, tagById) {
    var tags = kpiCol.tags ? kpiCol.tags : [];
    tags = tags.filter(function (id) { return !isGroupTag(tagById[id]); });
    var tempfilter = kpiCol.temporalGenerator;
    if (kpiCol.tagIdsOr && kpiCol.tagIdsOr.length > 0) {
        tags.push(kpiCol.tagIdsOr);
    }
    if (tagSlicerTagIds) {
        Object.keys(tagSlicerTagIds).forEach(function (key) {
            var tagIds = tagSlicerTagIds[Number(key)] || [];
            if (tagIds.length > 0) {
                tags.push(tagIds.sort(function (a, b) { return a - b; }));
            }
        });
    }
    var result = getSelectorColBasicDataString(tempfilter, tags);
    return result;
}
function getDataString(arr) {
    arr.sort(function (a, b) {
        var aa = Array.isArray(a) ? a[0] : a;
        var bb = Array.isArray(b) ? b[0] : b;
        return aa - bb;
    });
    var tags = arr.map(function (item) {
        if (Array.isArray(item)) {
            return item.join('|');
        }
        else {
            return "".concat(item);
        }
    });
    return "tags(".concat(tags.join(','), ")");
}
function sortKPI(filteredRows, kpiCols, sort) {
    var e_1, _a;
    var _b, _c;
    if (filteredRows.length === 0) {
        return filteredRows;
    }
    var sortByColIdx = kpiCols.findIndex(function (col) { return col.id === sort.colId; });
    var rootClusterParentPath = filteredRows[0].ParentId;
    var byParentByPath = {};
    try {
        for (var filteredRows_1 = __values(filteredRows), filteredRows_1_1 = filteredRows_1.next(); !filteredRows_1_1.done; filteredRows_1_1 = filteredRows_1.next()) {
            var row = filteredRows_1_1.value;
            var parentPath = row.ParentId;
            if (byParentByPath[parentPath]) {
                (_b = byParentByPath[parentPath]) === null || _b === void 0 ? void 0 : _b.push(row);
            }
            else {
                byParentByPath[parentPath] = [row];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (filteredRows_1_1 && !filteredRows_1_1.done && (_a = filteredRows_1.return)) _a.call(filteredRows_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var sortedData = [];
    function sortFunc(children) {
        var e_2, _a;
        var _b;
        var sortedChildren = children.sort(function (a, b) {
            var _a, _b, _c, _d, _e, _f;
            var aValue = (_c = (_b = (_a = a.data) === null || _a === void 0 ? void 0 : _a[sortByColIdx]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 0;
            var bValue = (_f = (_e = (_d = b.data) === null || _d === void 0 ? void 0 : _d[sortByColIdx]) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : 0;
            return sort.asc ? aValue - bValue : bValue - aValue;
        });
        try {
            for (var sortedChildren_1 = __values(sortedChildren), sortedChildren_1_1 = sortedChildren_1.next(); !sortedChildren_1_1.done; sortedChildren_1_1 = sortedChildren_1.next()) {
                var child = sortedChildren_1_1.value;
                sortedData.push(child);
                if (byParentByPath[child.objectId]) {
                    sortFunc((_b = byParentByPath[child.objectId]) !== null && _b !== void 0 ? _b : []);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (sortedChildren_1_1 && !sortedChildren_1_1.done && (_a = sortedChildren_1.return)) _a.call(sortedChildren_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
    sortFunc((_c = byParentByPath[rootClusterParentPath]) !== null && _c !== void 0 ? _c : []);
    return sortedData;
}
